import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Asset} from 'src/app/common/models/ai-reports/shared/assets';
import {AssetBase64Component} from './asset-base64/asset-base64.component';
import {AssetUrlComponent} from './asset-url/asset-url.component';
import {AssetSvgSourceComponent} from './asset-svg-source/asset-svg-source.component';
import {AssetSvgDefsComponent} from './asset-svg-defs/asset-svg-defs.component';
import {AssetFamilyTreeComponent} from './asset-family-tree/asset-family-tree.component';
import {AssetVisjsComponent} from './asset-visjs/asset-visjs.component';
import {AssetCytoscapeComponent} from './asset-cytoscape/asset-cytoscape.component';
import {AssetVideoComponent} from './asset-video/asset-video.component';
import {AssetPersonEventsComponent} from './asset-person-events/asset-person-events.component';

@Component({
  selector: 'app-asset',
  standalone: true,
  imports: [
    CommonModule,
    AssetBase64Component,
    AssetUrlComponent,
    AssetSvgSourceComponent,
    AssetSvgDefsComponent,
    AssetFamilyTreeComponent,
    AssetVisjsComponent,
    AssetCytoscapeComponent,
    AssetVideoComponent,
    AssetPersonEventsComponent,
  ],
  templateUrl: './asset.component.html',
  styleUrl: './asset.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetComponent {
  readonly asset = input.required<Asset>();
  readonly mode = input<'thumbnail' | 'view' | 'details'>('view');
  readonly tryAgain = output<string>();
}
